import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
import { SSRGetDoneMark } from '../helper/ssr-get-done-mark';
import { logger } from '../logger';
import { Route } from '../route';
import { submitter } from '../submitter/submitter';
import { BMEventsType } from '../types';
import { BasePageLoadMetric } from './base-page-load-metric';
import { pageLoadMetaMetric } from './page-load-meta-metric';
import { WebVitalsMetric } from './web-vitals-metric';
export var PageLoadMetric = /*#__PURE__*/function (_BasePageLoadMetric) {
  function PageLoadMetric() {
    _classCallCheck(this, PageLoadMetric);
    return _callSuper(this, PageLoadMetric, arguments);
  }
  _inherits(PageLoadMetric, _BasePageLoadMetric);
  return _createClass(PageLoadMetric, [{
    key: "startPageLoad",
    value: function startPageLoad() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        isInitial: false
      };
      pageLoadMetaMetric.startPageLoad(_objectSpread(_objectSpread({}, params), {}, {
        cancelStarted: 'startTime' in params
      }));
      this.watchUntil();
    }
  }, {
    key: "stop",
    value: function stop() {
      var _this$config$ssr;
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var stopTime = params.stopTime || window.performance.now();
      var pageLoadData = pageLoadMetaMetric.getDataToMerge();
      var metaMetricStopped = pageLoadMetaMetric.stop(params);
      if (!metaMetricStopped) {
        return false;
      }
      if (pageLoadData.isInitial && (_this$config$ssr = this.config.ssr) !== null && _this$config$ssr !== void 0 && _this$config$ssr.doneAsFmp) {
        if (!this.marks[BasePageLoadMetric.FMP]) {
          var mark = SSRGetDoneMark.getDoneMark();
          if (mark) {
            pageLoadMetaMetric.markFMP(mark);
          }
        } else {
          pageLoadMetaMetric.markFMP(this.marks[BasePageLoadMetric.FMP]);
        }
      }
      this.route = Route.getRoute();
      var metricStopped = this.stopPageLoad(pageLoadData, _objectSpread(_objectSpread({}, params), {}, {
        stopTime: stopTime
      }));
      if (!metricStopped) {
        return false;
      }
      var data = this.getData();
      if (!this.config.virtual) {
        submitter.queue(data);
      }
      logger.logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
      this.enqueueWebVitals();
      return true;
    }
  }, {
    key: "mark",
    value: function mark(_mark) {
      var timestamp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.performance.now();
      pageLoadMetaMetric.mark(_mark, timestamp);
    }
  }, {
    key: "markFMP",
    value: function markFMP(timestamp) {
      pageLoadMetaMetric.markFMP(timestamp);
    }
  }, {
    key: "getData",
    value: function getData() {
      var pageLoadMetaData = pageLoadMetaMetric.getData();
      return _objectSpread(_objectSpread({}, _superPropGet(PageLoadMetric, "getData", this, 3)([])), {}, {
        // marks and explicitTimings are available only in pageLoadMeta
        marks: pageLoadMetaData.marks,
        explicitTimings: pageLoadMetaData.explicitTimings
      });
    }
  }, {
    key: "enqueueWebVitals",
    value: function () {
      var _enqueueWebVitals = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _configChunk$BMEvents;
        var configChunk, webVitalMetric;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(this.config.virtual || !this.isInitial)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return", false);
            case 2:
              _context.next = 4;
              return submitter.config.configChunk;
            case 4:
              configChunk = _context.sent;
              if (configChunk !== null && configChunk !== void 0 && (_configChunk$BMEvents = configChunk[BMEventsType.WEB_VITALS].webVitals) !== null && _configChunk$BMEvents !== void 0 && _configChunk$BMEvents.enabled) {
                _context.next = 7;
                break;
              }
              return _context.abrupt("return", false);
            case 7:
              webVitalMetric = new WebVitalsMetric({
                key: this.config.key,
                route: this.route,
                startTime: this.startTime,
                stopTime: this.stopTime,
                pageVisibleState: this.pageVisibleState
              });
              submitter.queue(webVitalMetric.getData());
              logger.logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
              return _context.abrupt("return", true);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function enqueueWebVitals() {
        return _enqueueWebVitals.apply(this, arguments);
      }
      return enqueueWebVitals;
    }()
  }]);
}(BasePageLoadMetric);